import { FitCompany, Prospector } from '@clearkit/icons';
import { CKNavigationBar } from 'clearkit';
import { withRouter } from 'react-router';

import { List } from './List';
import {
  recentProspectsList,
  savedProspectsList,
  targetMarketList,
} from './mockData';

const ProspectorLists = () => {
  return (
    <CKNavigationBar
      className="bg-transparent border-r-0 !w-full !pt-0"
      isExpanded
    >
      <CKNavigationBar.Section className="pb-8">
        <List items={targetMarketList} title="Target Markets">
          <FitCompany />
        </List>
      </CKNavigationBar.Section>
      <CKNavigationBar.Section className="pt-8 space-y-8">
        <List items={recentProspectsList} title="Recent Prospect Lists">
          <Prospector />
        </List>
        <List items={savedProspectsList} title="Saved Prospect Lists">
          <Prospector />
        </List>
      </CKNavigationBar.Section>
    </CKNavigationBar>
  );
};

export default withRouter(ProspectorLists);
